import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IChat } from '../models';

@Injectable()
export class IndexDbChatService {
  public activeChat$ = new BehaviorSubject<IChat | null>(null);
}
